import type { EditTarget } from '@web-studio/shared-schemas';

/** Resolve click-to-edit target from a preview DOM element. */
export function resolveEditTargetFromElement(element: Element | null): EditTarget | null {
  const child = element?.closest('[data-edit-child]');
  if (!child) {
    return null;
  }

  const kind = child.getAttribute('data-edit-child');
  switch (kind) {
    case 'content-field': {
      const fieldKey = child.getAttribute('data-field-key');
      return fieldKey ? { kind: 'content-field', fieldKey } : null;
    }
    case 'media-field': {
      const fieldKey = child.getAttribute('data-field-key');
      return fieldKey ? { kind: 'media-field', fieldKey } : null;
    }
    case 'menu-item': {
      const columnIndex = Number(child.getAttribute('data-column-index'));
      const itemIndex = Number(child.getAttribute('data-item-index'));
      if (!Number.isFinite(columnIndex) || !Number.isFinite(itemIndex)) {
        return null;
      }
      return { kind: 'menu-item', columnIndex, itemIndex };
    }
    case 'menu-column': {
      const columnIndex = Number(child.getAttribute('data-column-index'));
      if (!Number.isFinite(columnIndex)) {
        return null;
      }
      return { kind: 'menu-column', columnIndex };
    }
    default:
      return null;
  }
}
